import { useSelector } from 'react-redux';

import HikingIcon from '@mui/icons-material/Hiking';
import { CircularProgress, Box, LinearProgress } from '@mui/material';

import {
	IContainerLoadingIndicatorProps,
	ILoadingState,
} from 'src/components/common/types/loadingTypes';

export const ContainerLoadingIndicator: React.FC<
	IContainerLoadingIndicatorProps
> = ({
	loadingKey,
	manualLoading = false,
	loaderType = 'circular',
	showAnimatedIcon,
}) => {
	const globalLoading = useSelector(
		(state: { loading: ILoadingState }) =>
			state.loading.loadingStates[loadingKey],
	);
	const isLoading = manualLoading || globalLoading;

	if (!isLoading) return null;

	return (
		<Box
			sx={{
				position: 'absolute',
				top: 0,
				left: 0,
				right: 0,
				bottom: 0,
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				backgroundColor: 'rgba(255, 255, 255, 0.7)',
				zIndex: 10,
				borderRadius: '4px',
			}}
		>
			{loaderType === 'linear' ? (
				<>
					<LinearProgress
						sx={{
							position: 'absolute',
							bottom: 0,
							left: 0,
							width: '100%',
							zIndex: 10,
							height: '3px',
							backgroundColor: '#BE3327',
							'& .MuiLinearProgress-bar': {
								backgroundColor: 'white',
							},
						}}
					/>
					{showAnimatedIcon && (
						<Box className='runLeftToRight'>
							<HikingIcon
								fontSize='inherit'
								sx={{ color: '#BE3327' }}
							/>
						</Box>
					)}
				</>
			) : (
				<CircularProgress sx={{ color: '#BE3327' }} />
			)}
		</Box>
	);
};

export default ContainerLoadingIndicator;
